import React from 'react';
import { useNavigate } from 'react-router-dom';

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Label } from 'recharts';

const StatisticChart = ({ data }) => {
   return (
    <div style={{ width: '100%', height: 400 }}>
      <h4 className="text-sm mb-4">Yearly Views Data</h4>
      <ResponsiveContainer>
        <LineChart data={data} margin={{ top: 20, right: 30, left: 10, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year">
            <Label value="Year" offset={-5} position="insideBottom" />
          </XAxis>
          <YAxis label={{ value: 'Views', angle: -90, position: 'insideLeft' }} />
          <Tooltip />
          <Line type="monotone" dataKey="total_views" stroke="#8884d8" strokeWidth={2} dot />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StatisticChart;
